<template>
  <div id="dashboard_page" class="centered" v-if="loaded">

    <div class="col-md-6">
      <div id="user_welcome">
        <span>ברוך הבא,</span>
        <h3 v-text="get_me().display_name"></h3>
        <label>יחצ"ן</label>
        <div class="pic_wrapper"  :style="'background-image:linear-gradient(90deg, rgba(0,0,0,0.16290266106442575) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.5046393557422969) 100%),url('+get_me().pic_parsed+')'">
          <div class="fade_pic"></div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="user_props">
        <div class="prop">
          <i :style="'background-image:url(' + ico_num_artists + ')'"></i>
          <div class="texts">
            <span v-text="items.length"></span>
            <label>לינקטונים</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(total_views)"></span>
            <label>סך כל ההאזנות</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_lpedia_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(num_lpedia)"></span>
            <label>צפיות בלינקיפדיה</label>
          </div>
        </div>
      </div>

    </div>

    <div class="clr"></div>

    <div class="col-md-6">

      <div class="col-md-12">
        <div class="">
           
             <div class="col-md-12">
                  <div class="box">
                      <h4>כניסות ללינקטונים שלי</h4>
                     <LineChart :x="false" :y="true" :data="chartdata" :options="options" :legend="false" :legend_label="'צפיות בלינקטונים שלי'"></LineChart>
                  </div>
              </div>
              <div class="col-md-6">
                <div id="banner"></div>
              </div>
              <div class="col-md-6">
                  <div class="box">
                        <h4>התחנות שצפו בי הכי הרבה</h4>
                         <PieChart :data="piechartdata" :options="{}"></PieChart>

                  </div>
              </div>
              <div class="clr"></div>
          </div>
        </div>
    </div>
    <div class="col-md-6">
      <div v-if="artists.length > 1">
          <h3>האומנים שלי</h3>


        <div class="artist_item" v-for="artist in artists" :key="artist.id">
        <router-link :to="'/dashboard/' + artist.id">
            <div class="inner">
            <div class="pic" :style="'background-image:url(' + artist.pic_tumb_big + ')'"></div>
            <div class="texts">
                <h3 v-text="artist.name"></h3>
            </div>
            </div>
            </router-link>
        </div>

          <div class="clr" style="margin-bottom:40px"></div>
      </div>

      
    </div>

  </div>
</template>

<script>
import LineChart from '@/components/new_charts/LineChart.vue';
import PieChart from '@/components/charts/PieChart.vue';

export default {
    components: {  LineChart, PieChart},
  data(){
    return {
      loaded: false,
      ico_num_artists: require('@/assets/ico_num_artists.svg'),
      ico_views: require('@/assets/ico_views.svg'),
      ico_lpedia_views: require('@/assets/ico_lpedia_views.svg'),
      
      artists: [],
      num_lpedia: 0,
      total_views: 0,

      has_artists: false,
      show_linktones: true,
      items: [
      ],
      
      options: {
      responsive: true,
      maintainAspectRatio: false,
        legend: {
            display: false
        },

      },
      chartdata: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979', 
            data: [40, 20]
          }
        ]
      },
      piechartdata: {
            labels: ['sdf', 'sdf', 'dfgfdgdfg'],
            datasets: [
                {
                    fill: true,
                    backgroundColor:  this.$store.color_array,
                    data: [5, 95, 20],
        // Notice the borderColor 
                    borderColor: this.$store.border_array,
                    borderWidth: [1,1]
                }
            ]
          },

      
    }
  },

  mounted(){
    var self = this;
    console.log(this.color_array[0]);
    this.api({ action: 'dashboard' }, function(data){ 
      
      self.num_lpedia = data.data.num_lpedia;
      self.items = data.data.items;
      self.artists = data.data.artists;
      self.total_views = data.data.total_views;
      self.chartdata.labels = Object.values(data.data.views).map(function(rows) { return rows.date_key});
      self.chartdata.datasets[0].data = Object.values(data.data.views).map(function(rows) { return parseInt(rows.value); });
      self.piechartdata.labels = Object.values(data.data.topStationsPie).map(function(rows) { return rows.name});
      self.piechartdata.datasets[0].data = Object.values(data.data.topStationsPie).map(function(rows) { return parseInt(rows.num); });
      self.loaded = true;
    });

  }
  
}
</script>

<style scoped lang="scss">

#linktones_list{
  h3{font-size: 22px;margin-bottom: 20px;}
  #items_table{
  .item{
    svg{color: rgba(0, 0, 0, 0.5);}
    &{margin-bottom: 20px;}
    .num{font-size: 50px;}
    .texts{padding: 0;}
    .option{width: 7%;padding-top: 20px;}
    .date{padding: 25px 0;}
  }
}
}
.col-md-12{padding: 0;}
#banner{height: 325px; background:  #a30303 ;width: 100%;border-radius: 10px;}
.box{box-shadow: 0 7px 17px 0 rgba(88, 91, 111, 0.08); background-color: #f4f4f4;border-radius: 10px;padding: 10px 20px;    margin-bottom: 25px;}
.box h4{color: #1e212a; font-size: 22px; font-family: "almoni-dl", "Assistant", sans-serif; padding: 10px}
.pic_wrapper{position: absolute;left: 0px;height: 145px; background-size: contain;width: 200px;background-repeat: no-repeat;top: 0;border-radius: 10px 0 0 10px}
.pic_wrapper .fade_pic{height: 100%;width: 100%;background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.31416316526610644) 50%, rgba(0,0,0,1) 100%);
}
#dashboard_page
{

  #user_welcome { height: 145px; background: #000; padding: 25px 40px; line-height: 0.9; border-radius: 10px; margin-bottom: 25px;position: relative;
    span {   font-size: 33px; font-weight: 900; color: #ff005e;}
    h3 {  font-size: 39px; color: #fff; font-weight: normal; }
      label { display: block; font-size: 23px; color:rgba(255,255,255,0.6);}
  }
  
  .user_props {
    & { display: flex; margin-top: 40px; }
    .prop { flex:1 0 auto; padding-left: 20px;
      i { float: right; background: top center no-repeat; background-size:contain; width:60px; height: 60px; margin-left: 10px;}
      .texts {float: right; line-height: normal;}
      span { display: block; font-size: 50px; font-weight: bold; margin-top: -15px; }
      label { display: block; font-size: 20px; color:rgba(0,0,0,0.7);}
    }
  }

  .graph_chart { background: #eee; padding:25px; text-align: center; font-weight: bold; border:1px solid #aaa; margin-bottom: 25px; }
}


.item{
  .share{display: flex;padding: 25px;}
  .share{
    .icon{margin: 0 10px;font-size: 14px;border: 1px solid;padding: 0px;border-radius: 100%;line-height: 1px;cursor: pointer; width:30px; height: 30px; text-align: center; line-height: 30px;}
    .icon:hover{transform: scale(1.04);}
  }
  .texts{
    h4{color: #000 !important;padding-top: 25px;padding-right: 25px;}
  }
.num{
  &{    font-size: 51px;padding-top: 19px;color: #ff1661 !important;}
  p{    font-size: 17px; margin-top: 4px;}
}
.active{color: #ff1661;}
.option{
  &{text-align: center;padding-top: 9px;width: 10%;cursor: pointer;font-size: 16px;font-weight: 700;}
  .svg-inline--fa{    font-size: 35px;text-align: center;margin-bottom: -3px;}
}
}


.artist_item {
  .inner { background: #fff; border-radius: 33px; position: relative; -moz-transition:all 0.2s ease 0s;-o-transition:all 0.2s ease 0s;-webkit-transition:all 0.12s ease 0s;transition:all 0.2s ease 0s; }
  .pic { border-radius: 33px; padding-bottom: 100%; background: center center no-repeat; background-size: cover; 
      &::after { content: ""; display: block; position: absolute; left: 0px; top: 0px; width:100%; height: 100%;  border-radius: 33px; overflow: hidden;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.23);
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.7));
      }
  }
  .texts { 
      &{ position: absolute; bottom: 0px; right: 0px; left: 0px; padding:15px 15px; color: #fff; }
      h3 { font-size: 25px; font-weight: 500; margin-bottom: 4px; }
      h4 { font-size: 20px; font-weight: 200; }
      .date { font-size: 16px; font-weight: 200; opacity: 0.6; }
  }
}

</style>